module.exports = __webpack_public_path__ + "img/4ff47b9.svg";